import { render, staticRenderFns } from "./BusinessFoldersView.vue?vue&type=template&id=2e8e992c&lang=pug&"
import script from "./BusinessFoldersView.vue?vue&type=script&lang=js&"
export * from "./BusinessFoldersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports